// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8b39e1fc","667":"efd5ed11"}[chunkId] + ".chunk.js";
};